class CteFilter {
  static get $inject() {
    return ['gql', '$scope']
  }

  constructor(gql, $scope) {
    this.gql = gql
    this.filter = {}

    this.apply = (fun) => $scope.$apply(fun)

    $scope.$watch(() => this.filter, () => {
      setTimeout(() => this.apply(() => this.submit()), 0)
    }, true)
  }

  $onInit() {
    this.ngModelCtrl.$render = () => {
      if (this.ngModelCtrl.$viewValue) {
        this.filter = this.ngModelCtrl.$viewValue
      }
    }
  }

  submit() {
    if (this.form && this.form.$valid) {
      this.updateFilter()
    } else {
      this.ngModelCtrl.$setViewValue(null)
    }
  }

  updateFilter() {
    let filter = angular.copy(this.filter)

    for (let key in filter) if (filter.hasOwnProperty(key) && filter[key] === "") {
      delete filter[key]
    }

    if (filter.periodo) {
      if (filter.periodo.inicial)
        filter.emissaoInicial = filter.periodo.inicial.toISOString()

      if (filter.periodo.final)
        filter.emissaoFinal = filter.periodo.final.toISOString()
    }

    delete filter.periodo

    if (filter.numero || filter.chave || filter.chaveNfe) {
      delete filter.emissaoInicial
      delete filter.emissaoFinal
    }

    if (/\d/.test(filter.participante)) {
      filter.participante = filter.participante.replace(/\.|\-|\//g, '')
    }

    this.ngModelCtrl.$setViewValue(filter)
  }
}

angular.module('eficienciaFiscalModule').component('cteFilter', {
  controller: CteFilter,
  bindings: {
    contratoId: '<'
  },
  require: {
    ngModelCtrl: 'ngModel'
  },
  template: `
    <form class="fade-animation" name="$ctrl.form" ng-submit="$ctrl.submit()">
      <div class="row">
        <ef-filiais-selector class="form-group col-sm-12" name="filiaisIds" ng-model="$ctrl.filter.filiaisIds"
          contrato-id="$ctrl.contratoId" ferramenta="arquivos-digitais" cache-as="cte-list" required>
        </ef-filiais-selector>
        <div class="form-group col-sm-8 col-md-6 col-lg-4">
          <label>
            Data de emissão
            <i class="fa fa-trash-o text-danger cursor-pointer" ng-click="$ctrl.filter.periodo = undefined"
              ng-if="$ctrl.filter.periodo"></i>
          </label>
          <periodo-input ng-model="$ctrl.filter.periodo"></periodo-input>
        </div>
        <div class="form-group col-sm-4 col-md-2 col-lg-2">
          <label>
            Número
            <i class="fa fa-trash-o text-danger cursor-pointer" ng-click="$ctrl.filter.numero = undefined"
              ng-if="$ctrl.filter.numero"></i>
          </label>
          <input type="text" class="form-control" ng-model="$ctrl.filter.numero" ng-model-options="{ debounce: 500 }">
        </div>
        <div class="form-group col-sm-6 col-md-4 col-lg-6">
          <label>
            Participante
            <i class="fa fa-trash-o text-danger cursor-pointer" ng-click="$ctrl.filter.participante = undefined"
              ng-if="$ctrl.filter.participante"></i>
          </label>
          <input type="text" class="form-control" placeholder="Razão Social, CNPJ" ng-model="$ctrl.filter.participante"
            ng-model-options="{ debounce: 500 }">
        </div>
        <div class="form-group col-sm-6 col-md-6 col-lg-4">
          <label>
            Chave CT-e
            <i class="fa fa-trash-o text-danger cursor-pointer" ng-click="$ctrl.filter.chave = undefined"
              ng-if="$ctrl.filter.chave"></i>
          </label>
          <input type="text" class="form-control" ng-model="$ctrl.filter.chave" ng-model-options="{ debounce: 500 }">
        </div>
        <div class="form-group col-sm-6 col-md-6 col-lg-4">
          <label>
            Chave NF-e
            <i class="fa fa-trash-o text-danger cursor-pointer" ng-click="$ctrl.filter.chaveNfe = undefined"
              ng-if="$ctrl.filter.chaveNfe"></i>
          </label>
          <input type="text" class="form-control" ng-model="$ctrl.filter.chaveNfe" ng-model-options="{ debounce: 500 }">
        </div>
        <div class="form-group col-sm-6 col-md-4 col-lg-4">
          <label>
            Participação
            <i class="fa fa-trash-o text-danger cursor-pointer" ng-click="$ctrl.filter.participacao = undefined"
              ng-if="$ctrl.filter.participacao != undefined">
            </i>
          </label>
          <select class="form-control" ng-model="$ctrl.filter.participacao">
            <option value="REMETENTE">Remetente</option>
            <option value="TOMADOR">Tomador</option>
            <option value="DESTINATARIO">Destinatário</option>
            <option value="RECEBEDOR">Recebedor</option>
            <option value="EXPEDIDOR">Expedidor</option>
          </select>
        </div>

        <div class="form-group col-sm-4 col-md-2 col-lg-2">
          <label for="" class="hidden-xs hidden-sm hidden-lg">&nbsp;</label>
          <button type="submit" class="btn btn-primary btn-block"><i class="fa fa-refresh"></i> Atualizar</button>
        </div>
      </div>
    </form>
  `
})
